// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  VillageFigure,
} from "./types";


export default __t.row({
  owner: __t.identity().primaryKey(),
  worldId: __t.u64().name("world_id"),
  villageId: __t.u64().name("village_id"),
  spot: __t.u8(),
  get figures() {
    return __t.array(VillageFigure);
  },
  talkNpc: __t.u64().name("talk_npc"),
  at: __t.timestamp(),
});
